import { render, staticRenderFns } from "./project-cart-form.vue?vue&type=template&id=5c206132&"
import script from "./project-cart-form.vue?vue&type=script&lang=js&"
export * from "./project-cart-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports